import { SKU_STATUS } from '../enums/sku';

/**
 * getProductStatusValue
 * @param {Boolean} isEOL end of life product: 0, 1
 * @param {Boolean} isActive active product: 0, 1
 * @returns {String}
 */
export const getProductStatusValue = (isEOL = null, isActive = null) => {
	let status = null;

	// Mapping status param with status options
	if (isEOL === 1 || isEOL === true) {
		status = SKU_STATUS.EOL;
	} else if (isActive === 1 || isActive === true) {
		status = SKU_STATUS.ACTIVE;
	} else if (isActive === 0 || isActive === false) {
		status = SKU_STATUS.INACTIVE;
	}

	return status;
};

/**
 * use to convert string to skus
 * @param {String} value ex: '190199221192; 190199221192;'
 * @returns {Array} ['190199221192', '190199221192']
 */
export const convertToSkuIds = (value = '') => {
	const skus = value.split(';');
	return skus.reduce((acc, cur) => {
		const sku = cur.trim();
		const isEmpty = sku === '';
		if (!isEmpty) {
			acc.push(sku);
		}
		return acc;
	}, []);
};